import { useContext } from "react";
import { AppContext } from "../App";

export function useAppState() {
  return useContext(AppContext);
}
